import React from 'react';
import { Row, Col } from 'react-bootstrap';
import classNames from 'clsx';
import LanguageDropdown from '../shop/LanguageDropdown';
import ShopLogo from '../../assets/images/shop_logo_web.png';

const HeaderWeb = ({ className }) => {
  const headerClassName = classNames(
    'web-header-section header-section header-section-lg',
    className,
  );

  return (
    <section className={headerClassName}>
      <div className="web-header">
        <Row>
          <Col>
            <div className="text-center logo">
              <a href={`/shop`} className="logo-container">
                <img src={ShopLogo} className="logo-img logo-img-web" alt="360VUZ" />
              </a>
            </div>
          </Col>
          <Col>
            <div className="menu">
              <LanguageDropdown />
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default HeaderWeb;
